module.exports = __webpack_public_path__ + "img/orbital-substation.175f941b.png";